import { updateNotification } from "./utils/updateNotification";
import { events } from "@planzone/events";
import { createStateReducer } from "../utils/createStateReducer";
import { pushIf } from "./utils/pushIf";
import { initialState } from "./initialState";

const reduceFillAccountNotificationState = createStateReducer(initialState, {
  [events.fillAccountSucceeded]: (state) => ({
    ...state,
    queue: updateNotification(
      {
        key: "fillAccount",
        flags: ["success"],
        args: { success: "true" },
      },
      state.queue,
    ),
  }),
  [events.fillAccountFailed]: (state, { error }) => ({
    ...state,
    queue: updateNotification(
      {
        key: "fillAccount",
        flags: pushIf({
          failure: !error.alreadyConfirmed,
          alreadyConfirmed: error.alreadyConfirmed,
        }),
        args: { failure: "true" },
      },
      state.queue,
    ),
  }),
});

export { reduceFillAccountNotificationState };
